import React from "react";
import "../styles/Home.css";
import Homebanner from "../Page-section/Home/Homebanner";
import MadhumehShowcase from "../Page-section/Home/MadhumehShowcase";
import TestimonialSlider from "../Page-section/Home/TestimonialSlider";
import VideoSection from "../Page-section/Home/VideoSection";
import AboutSection from "../Page-section/Home/AboutSection";
import CertificationSection from "../Page-section/Home/certification";
// import CategorySlider from "../Page-section/Home/CategorySlider";
import ShopNow from "../Page-section/Home/ShopNow";

function Home() {
  return (
    <div>
      <Homebanner />
      {/* <CategorySlider /> */}
      <MadhumehShowcase />
      {/* <ShilajitShowcase /> */}
      {/* <StaminaShowcase /> */}
      <ShopNow />
      <AboutSection />
      <VideoSection />
      <TestimonialSlider />
      <CertificationSection />
      <section className="seo-keywords">
        <h2>Ayurvedic wellness for men and daily health</h2>
        <p>
          Ayurvedic supplements, shilajit, shilajit plus, stamina tablet, men
          wellness, energy and vitality, bone and iron support, herbal health,
          natural wellness, immunity support, digestion care, diabetes support.
        </p>
      </section>
    </div>
  );
}

export default Home;
